import React, { useContext } from "react";
import { Form } from "antd";
import moment from "moment";
import { getFormItemLabel, getFormItemVaidation } from "../util/helpers";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import Spacer from "../layouts/Spacer";
import { DatePicker, TimePicker } from "../antOverrides";
import RestrictedContext from "../util/RestrictedContext";

const DateAndHourItem = (props) => {
  const DatePickerComponent = ({
    value,
    onChange,
    disabled,
    disabledDate,
    disabledHours,
    disabledMinutes,
    even,
  }) => {
    const onDateChange = (val) => {
      onChange(val ? moment(val).startOf("day").format() : val);
      // setNewDate(val, value);
    };
    const onHourChange = (time, timeString) => {
      const newDate = value ? moment(value) : moment();
      newDate.set({
        hour: time ? time.get("hour") : null,
        minute: time ? time.get("minute") : null,
      });
      onChange(time ? newDate.format() : null);
    };

    const disabledTime = () => ({
      disabledHours: () => disabledHours(),
      disabledMinutes: (selectedHour) => disabledMinutes(selectedHour),
    });

    const restricted = useContext(RestrictedContext);
    const format = "HH:mm";

    return (
      <div style={{ display: "flex" }}>
        <DatePicker
          disabled={disabled || !restricted["hasWritePermission"]}
          value={value ? moment(value) : undefined}
          format={dateFormat}
          onChange={onDateChange}
          disabledDate={disabledDate}
          style={even ? { flex: 1 } : {}}
        />
        <Spacer horizontal={true} />

        <TimePicker
          disabled={disabled || !restricted["hasWritePermission"]}
          value={value ? moment(value) : undefined}
          format={format}
          onChange={onHourChange}
          inputReadOnly={false}
          minuteStep={15}
          disabledTime={disabledHours && disabledTime}
          style={even ? { flex: 1 } : {}}
        />
      </div>
    );
  };
  const {
    name,
    required,
    category,
    dynamicFieldName,
    disabled,
    hideLabel,
    disabledDate,
    disabledHours,
    disabledMinutes,
    even,
  } = props;
  const intl = useIntl();
  const label = hideLabel
    ? null
    : getFormItemLabel(intl, category, name, dynamicFieldName);
  const arr = [];
  if (required) {
    arr.push("required");
  }
  const rules = getFormItemVaidation(intl, label, arr);
  const dateFormat = "DD/MM/YYYY";
  const restricted = useContext(RestrictedContext);

  return (
    <Form.Item
      label={hideLabel ? null : label}
      name={name}
      rules={rules}
      // normalize={(value, prevValue, prevValues) =>
      //   value ? moment(value).toISOString(true) : value
      // }
    >
      <DatePickerComponent
        disabled={disabled || !restricted["hasWritePermission"]}
        disabledDate={disabledDate}
        disabledHours={disabledHours}
        disabledMinutes={disabledMinutes}
        even={even}
      />
    </Form.Item>
  );
};

DateAndHourItem.propTypes = {
  name: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  required: PropTypes.bool,
  category: PropTypes.string,
};

export default DateAndHourItem;
